module.exports = __webpack_public_path__ + "static/ff-saleslanding-icon-mental.d5e763c4.png";